module.exports = __webpack_public_path__ + "static/media/Bicycle.d8cbc7cd.svg";